module.exports = __webpack_public_path__ + "static/media/trustpilot_white_transperant.dd2f5949.png";